import React, { useState } from "react";
import {
  EuiForm,
  EuiFormRow,
  EuiFieldText,
  EuiSelect,
  EuiButton,
} from "@elastic/eui";
import axios from "axios";
import { getApiUrl } from "../utils/api";

const CreateAgentForm = ({ course, onSuccess }) => {
  const [configName, setConfigName] = useState("");
  const [mode, setMode] = useState("step-by-step"); 
  const [defaultAssistanceLevel, setDefaultAssistanceLevel] = useState(1);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        config_name: configName,
        mode,
        default_assistance_level: defaultAssistanceLevel,
        course_number: course.course_number,
        course_name: course.course_name,
      };

      await axios.post(getApiUrl("/api/config/create"), payload);
      onSuccess();
    } catch (err) {
      console.error("Failed to create agent:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <EuiForm component="form">
      <EuiFormRow label="Agent Name">
        <EuiFieldText
          value={configName}
          onChange={(e) => setConfigName(e.target.value)}
        />
      </EuiFormRow>

      <EuiFormRow label="Default AI Assistance Level">
        <EuiSelect
          options={[
            { value: 1, text: "Level 1 - Idea Spark (no code)" },
            { value: 2, text: "Level 2 - Code Check (review only)" },
            { value: 3, text: "Level 3 - Debug Helper (trace errors)" },
            { value: 4, text: "Level 4 - Co-Builder (draft snippets)" },
            { value: 5, text: "Level 5 - AI Only (full solutions)" },
          ]}
          value={defaultAssistanceLevel}
          onChange={(e) => setDefaultAssistanceLevel(parseInt(e.target.value, 10))}
        />
      </EuiFormRow>

      <EuiButton onClick={handleSubmit} isLoading={loading} fill>
        Create Agent
      </EuiButton>
    </EuiForm>
  );
};

export default CreateAgentForm;
